import { render, staticRenderFns } from "./JVXETableDemo.vue?vue&type=template&id=1b55fc0d&scoped=true&"
import script from "./JVXETableDemo.vue?vue&type=script&lang=js&"
export * from "./JVXETableDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55fc0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b55fc0d')) {
      api.createRecord('1b55fc0d', component.options)
    } else {
      api.reload('1b55fc0d', component.options)
    }
    module.hot.accept("./JVXETableDemo.vue?vue&type=template&id=1b55fc0d&scoped=true&", function () {
      api.rerender('1b55fc0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVXETableDemo.vue"
export default component.exports